module.exports = __webpack_public_path__ + "img/logo1.9fd6b211.png";